import { Box, Typography } from '@mui/material';
import BannerImage from '@acorn-portal/shared/src/assets/streetcover/payment-successful.svg';
import { FC } from 'react';

interface IProps {
	text?: React.ReactNode;
}

const StreetCoverBanner: FC<IProps> = ({ text }) => {
	return (
		<Box
			sx={(theme) => ({
				position: 'relative',
				display: 'flex',
				justifyContent: 'center',
				padding: 2,
				overflow: 'hidden',
				paddingBottom: '30%',
				[theme.breakpoints.down('md')]: {
					height: '250px',
				},
			})}
		>
			<img
				src={BannerImage}
				alt='Street Cover Declined'
				style={{
					position: 'absolute',
					top: 0,
					left: 0,
					width: '100%',
					height: '100%',
					objectFit: 'cover',
					zIndex: 1,
				}}
			/>
			<Box
				sx={(theme) => ({
					position: 'absolute',
					zIndex: 200,
					top: '82%',
					transform: 'translateY(-50%)',
					overflow: 'hidden',
					width: 'auto',
					margin: 'auto',
					[theme.breakpoints.down('md')]: {
						fontSize: '4vw',
						transform: 'translateY(-50%)',
					},
					[theme.breakpoints.down('sm')]: {
						fontSize: '5vw',
						transform: 'translateY(-50%)',
					},
				})}
			>
				<Typography
					variant='h4'
					sx={(theme) => ({
						color: theme.palette.common.white,
						fontSize: '2rem',
						margin: '1.8rem',
						padding: '1rem',
						fontWeight: 600,
						[theme.breakpoints.down('md')]: {
							fontSize: '1.5rem',
							margin: '1rem',
							padding: '0.8rem',
						},
						[theme.breakpoints.down('sm')]: {
							fontSize: '1.2rem',
							margin: '0.6rem',
							padding: '0.6rem',
						},
					})}
				>
					{text}
				</Typography>
			</Box>
		</Box>
	);
};

export default StreetCoverBanner;
